import React, { useState, useEffect, useCallback } from 'react';

const ScrollProgress = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  const updateScrollProgress = useCallback(() => {
    const scrollPx = document.documentElement.scrollTop;
    const winHeightPx = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const calculated = (scrollPx / winHeightPx) * 100;
    setScrollProgress(calculated);
  }, []); // Empty deps - DOM values computed fresh on each scroll

  useEffect(() => {
    window.addEventListener('scroll', updateScrollProgress);
    return () => window.removeEventListener('scroll', updateScrollProgress);
  }, [updateScrollProgress]);

  return (
    <div className="fixed top-0 left-0 right-0 z-50 h-1 bg-gray-900">
      <div
        className="h-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 transition-all duration-150"
        style={{ width: `${scrollProgress}%` }}
      />
    </div>
  );
};

export default ScrollProgress;
